import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";

export default function NoDataRow({
  columnsLength,
  message = "",
  withBody = false,
}) {
  let Row = (
    <TableRow>
      <TableCell
        align="center"
        colSpan={columnsLength}
        sx={{
          borderColor: "var(--palette-stroke)",
          color: "var(--palette-text)",
        }}
      >
        <Typography>{message}</Typography>
      </TableCell>
    </TableRow>
  );
  return withBody ? <TableBody>{Row}</TableBody> : Row;
}
